import { c as _c } from "react/compiler-runtime";
import { Control, FieldValues } from 'react-hook-form';
import { FormAwareDatePickerInput } from '@/components/form/formAwareInputs/FormAwareDatePickerInput';
import { FieldNameFromFormShape } from '@/types/react-hook-form';
interface FundingDateInputProps<FormShape extends FieldValues> {
  control: Control<FormShape>;
  label: string;
  disabled?: boolean;
  fieldName: FieldNameFromFormShape<FormShape>;
  minDate: Date;
}
export function FundingDateInput(t0) {
  const $ = _c(16);
  const {
    control,
    disabled,
    label,
    fieldName,
    minDate
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== label) {
    t1 = value => {
      if (disabled) {
        return;
      }
      if (!value) {
        return `${label} is required.`;
      }
    };
    $[0] = disabled;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== disabled || $[4] !== minDate) {
    t2 = value_0 => {
      if (disabled) {
        return;
      }
      if (new Date(value_0) < minDate) {
        return "Date must be after funding date";
      }
    };
    $[3] = disabled;
    $[4] = minDate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      required: t1,
      minDate: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== control || $[10] !== disabled || $[11] !== fieldName || $[12] !== label || $[13] !== minDate || $[14] !== t3) {
    t4 = <FormAwareDatePickerInput control={control} disabled={disabled} required={true} label={label} validation={t3} minDate={minDate} fieldName={fieldName} />;
    $[9] = control;
    $[10] = disabled;
    $[11] = fieldName;
    $[12] = label;
    $[13] = minDate;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}